import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Button from '@nubank/nuds-web/components/Button/Button';

import ProgressBar from '../ProgressBar/ProgressBar';

function FormHeader({
  handleDrawerClose,
  currentStep,
  totalSteps,
  prevStep,
}) {
  const isTheFirstStep = currentStep === 1;
  const isResultStep = currentStep === totalSteps;
  const isLoadingStep = currentStep === totalSteps - 1;
  const shouldDisplayBackButton = !isTheFirstStep && !isResultStep && !isLoadingStep;
  const shouldDisplayHeader = !isResultStep && !isLoadingStep;
  const removeLoadingAndResultSteps = 2;
  const calculateStepProgress = step => step * (100 / (totalSteps - removeLoadingAndResultSteps));

  return (
    shouldDisplayHeader ? (
      <Grid
        row
        alignItems="center"
      >
        <Grid col="2">
          <div>
            {shouldDisplayBackButton && (
              <Button
                variant="basic"
                styleVariant="primary"
                onClick={prevStep}
                iconProps={{
                  name: 'arrow-left', title: 'Voltar',
                }}
              />
            )}
          </div>
        </Grid>
        <Grid col="4" offset="2">
          <ProgressBar
            percentage={calculateStepProgress(currentStep)}
            height="0.125rem"
          />
        </Grid>
        <Grid col="2" offset="2">
          <Button
            variant="basic"
            styleVariant="primary"
            onClick={handleDrawerClose}
            iconProps={{
              name: 'x', title: 'Fechar',
            }}
          />
        </Grid>
      </Grid>
    ) : (
      <Grid
        row
        alignItems="center"
      >
        <Grid col="auto" spacingVertical="6x" />
      </Grid>
    )
  );
}

FormHeader.propTypes = {
  currentStep: PropTypes.number.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default FormHeader;
